import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewSwipeToDismissService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getId = (): string => 'swipeToDismiss';

  getTitle = (): string => 'Swipe to dismiss';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'swipe-to-dismiss/0', 'title': 'Medium item', 'theme': 'layout1' },
      { 'url': 'swipe-to-dismiss/1', 'title': 'Medium item with location', 'theme': 'layout2' },
      { 'url': 'swipe-to-dismiss/2', 'title': 'Full with image + left swipe', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'headerTitle': 'Medium item',
      'listHeaderTitle': 'Upcoming',
      'listTitle': 'History Booking',
      "title": "Dick's Hotel",
      "description": "Check in",
      "data": "16 Jan 2020",
      "time": "08:00 am",
      "image": "assets/imgs/avatar/4.jpg",
      'items': [
        {
          'id': 1,
          "title": "Australia Hotel",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/1.jpg",
          "details": "4.3",
          "icon": "star",
          'booking': "Book Again",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 2,
          "title": "Grace Hotel",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/2.jpg",
          "details": "4.5",
          "icon": "star",
          'booking': "Book Again",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 3,
          "title": "Exchange Hotel",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/3.jpg",
          "details": "5",
          "icon": "star",
          'booking': "Book Again",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 4,
          "title": "Star City Casino",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/4.jpg",
          "details": "4.7",
          'booking': "Book Again",
          "icon": "star",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 5,
          "title": "Mo Gridder's",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/11.jpg",
          "details": "4.3",
          "icon": "star",
          'booking': "Book Again",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 6,
          "title": "White Bay Hotel",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/9.jpg",
          "details": "5",
          "icon": "star",
          'booking': "Book Again",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 7,
          "title": "Newport Arms Hotel",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/6.jpg",
          "details": "4",
          "icon": "star",
          'booking': "Book Again",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 8,
          "title": "White Bay Hotel",
          "description": "Rosa Room",
          "image": "assets/imgs/avatar/8.jpg",
          "details": "4.1",
          "icon": "star",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        }
      ]
    };
  }


  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'headerTitle': 'Medium item with location',
      'items': [
        {
          'id': 1,
          "title": "O’Donnell’s Pub",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/8.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 2,
          "title": "4th Avenue Pub",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 3,
          "title": "Perdition",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/6.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 4,
          "title": "John Sullivan’s",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/5.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 5,
          "title": "Mo Gridder's",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/12.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 6,
          "title": "BurritoVille",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/11.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 7,
          "title": "PKorilla BBQ",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/10.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 8,
          "title": "Kennedy Fried Chicken",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/9.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'headerTitle': 'Full with image + left swipe',
      'items': [
        {
          'id': 1,
          'title': 'The Spectator Hotel',
          'description': ' South Carolina',
          'image': 'assets/imgs/background/5.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 2,
          'title': 'The Lowell,',
          'description': 'New York City',
          'image': 'assets/imgs/background/6.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 3,
          'title': 'Vidanta Nuevo Vallarta',
          'description': 'Mexico',
          'image': 'assets/imgs/background/7.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 4,
          'title': 'The Temple House',
          'description': 'China',
          'image': 'assets/imgs/background/8.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 5,
          'title': 'The Milestone Hotel',
          'description': 'London',
          'image': 'assets/imgs/background/9.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        }
      ]
    };
  }

  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('listView/swipeToDismiss/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
